module.exports = __webpack_public_path__ + "img/img3.831836f4.png";